import { render, staticRenderFns } from "./SeletorData.vue?vue&type=template&id=14713124&"
import script from "./SeletorData.vue?vue&type=script&lang=js&"
export * from "./SeletorData.vue?vue&type=script&lang=js&"
import style0 from "./SeletorData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SeletorData.vue"
export default component.exports